const Header = {
  lastScrollTop: -1,
  scrollTop: window.scrollY,
  header: document.querySelector('#header'),

  setScroll: function (scrollTop, lastScrollTop) {
    const _this = this;

    if (scrollTop <= 0) {
      _this.header.classList.add('scroll-up');
      _this.header.classList.remove('scroll-down');
      _this.header.classList.add('on-top');
    } else {
      if (_this.header.classList.contains('on-top')) {
        _this.header.classList.remove('on-top');
      }
      if (scrollTop > lastScrollTop) {
        _this.header.classList.add('scroll-down');
        _this.header.classList.remove('scroll-up');
      } else {
        _this.header.classList.add('scroll-up');
        _this.header.classList.remove('scroll-down');
      }
    }
  },

  searchButton: function () {
    const searchButton = document.querySelector('[data-action="show-form-search"]');
    const searchButtonClose = document.querySelector('[data-action="hide-form-search"]');
    const formSearch = document.querySelector('.header-search');
    const formSearchInput = document.querySelector('.header-search input');

    if (!formSearch) return;

    searchButton &&
      searchButton.addEventListener('click', () => {
        formSearch.classList.toggle('-active', !formSearch.classList.contains('-active'));

        formSearchInput && formSearchInput.focus();

        if (window.innerWidth > 768) {
          document.addEventListener('scroll', () => {
            formSearch.classList.remove('-active');
          });
        }
      });

    searchButtonClose &&
      searchButtonClose.addEventListener('click', () => {
        formSearch.classList.remove('-active');
      });

    // Desativa o popup de busca - quando necessário
    formSearch.addEventListener('click', (e) => {
      if (e.target.className == 'header-search -active') {
        formSearch.classList.remove('-active');
      }
    });
  },

  desktopSubmenu: function () {
    const desktopMenus = Array.from(document.querySelectorAll('#header .menu .menu-item.has-submenu'));
    const closeDelay = 180;

    if (desktopMenus.length === 0) return;

    const setActiveItem = (submenuItems, activeItem) => {
      submenuItems.forEach((item) => {
        item.classList.toggle('-active', item === activeItem);
      });
    };

    const closeMenu = (menu) => {
      menu.classList.remove('-open');
    };

    const clearCloseTimer = (menu) => {
      if (!menu.dataset.closeTimerId) return;

      window.clearTimeout(Number(menu.dataset.closeTimerId));
      delete menu.dataset.closeTimerId;
    };

    const scheduleClose = (menu) => {
      clearCloseTimer(menu);

      const timerId = window.setTimeout(() => {
        closeMenu(menu);
        delete menu.dataset.closeTimerId;
      }, closeDelay);

      menu.dataset.closeTimerId = String(timerId);
    };

    const closeOtherMenus = (currentMenu) => {
      desktopMenus.forEach((menu) => {
        if (menu === currentMenu) return;

        clearCloseTimer(menu);
        closeMenu(menu);
      });
    };

    desktopMenus.forEach((menu) => {
      const menuTitle = menu.querySelector(':scope > .menu-title');
      const submenu = menu.querySelector(':scope > .submenu');
      const submenuItems = Array.from(menu.querySelectorAll('.submenu .submenu-item.has-submenu'));

      const syncActiveItem = () => {
        const currentActive = submenuItems.find((item) => item.classList.contains('-active'));
        const firstItem = submenuItems[0];

        if (!firstItem) return;

        setActiveItem(submenuItems, currentActive || firstItem);
      };

      const openMenu = () => {
        clearCloseTimer(menu);
        closeOtherMenus(menu);
        menu.classList.add('-open');
        syncActiveItem();
      };

      if (submenuItems.length > 0) {
        syncActiveItem();

        submenuItems.forEach((item) => {
          item.addEventListener('pointerenter', () => {
            if (!menu.classList.contains('-open')) return;

            clearCloseTimer(menu);
            setActiveItem(submenuItems, item);
          });

          item.addEventListener('focusin', () => {
            openMenu();
            setActiveItem(submenuItems, item);
          });
        });
      }

      menuTitle &&
        menuTitle.addEventListener('pointerenter', () => {
          openMenu();
        });

      menuTitle &&
        menuTitle.addEventListener('focusin', () => {
          openMenu();
        });

      menuTitle &&
        menuTitle.addEventListener('mouseleave', () => {
          scheduleClose(menu);
        });

      submenu &&
        submenu.addEventListener('pointerenter', () => {
          if (!menu.classList.contains('-open')) return;

          clearCloseTimer(menu);
          menu.classList.add('-open');
        });

      submenu &&
        submenu.addEventListener('mouseleave', () => {
          scheduleClose(menu);
        });

      menu.addEventListener('focusout', (event) => {
        if (menu.contains(event.relatedTarget)) return;

        clearCloseTimer(menu);
        closeMenu(menu);
      });
    });
  },

  init: function () {
    const _this = this;

    _this.setScroll(_this.scrollTop, _this.lastScrollTop);
    _this.searchButton();
    _this.desktopSubmenu();

    // Atualiza o header quando a page recebe scroll
    window.addEventListener('scroll', function () {
      const newSt = window.scrollY;

      _this.setScroll(newSt, _this.lastScrollTop);
      _this.lastScrollTop = newSt;
    });
  },
};

export default Header;
